<template>
  <a
    :href="href"
    class="share-icon"
    :class="platform"
    @click="trackSocial(platform)"
    :target="blank ? '_blank' : '_self'"
  >
    <slot></slot>
  </a>
</template>

<script>
import { trackSocial } from '@/utils/track'

export default {
  name: 'ShareIcon',
  props: {
    href: {
      type: String,
      required: false
    },
    platform: {
      type: String,
      required: true
    },
    blank: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    trackSocial (platform) {
      trackSocial(platform)
    }
  }
}
</script>

<style lang="scss" scoped>
.share-icon {
  height: 46px;
  width: 46px;
  margin: 0 8px;
  display: inline-block;
  vertical-align: middle;
  font-size: 0;

  svg {
    height: 46px;
    width: 46px;
  }
}
</style>
